import React from "react";
import { IColuna } from "../../../types/IColuna";

export type HeaderUltimasComprasProps = {
  colunas: IColuna[];
};
const traduzirColuna = (nomeColuna: string) => {
  return nomeColuna == "Informações" ? "" : nomeColuna;
};

export const HeaderUltimasCompras = (props: HeaderUltimasComprasProps) => {
  return (
    <>
      <tr>
        {props.colunas.map(
          (coluna, key) =>
            coluna.Selecionada && (
              <th key={key} className={coluna.Classes}>
                {traduzirColuna(coluna.Nome)}
                {coluna.Selecionada}
              </th>
            )
        )}
      </tr>
    </>
  );
};
